var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * @desc xAxis
 */
import { Group, Line, Arc, Sector, Polygon } from '../../element';
import { createRichText } from '../../rich';
import Axis from './axis';
import { LinearScale, OrdinalScale, LogScale } from '../../scale';
import { axisType } from '../../interface/axis';
import { degToRad } from '../../utils/math';
import normalizeToArray from '../../utils/normalizeToArray';
import { getCircleLayoutLabelAlign } from '../../utils/textLayout';
import { eventGraph } from '../../action';
/**
 * default
 */
var AngleAxis = /** @class */ (function (_super) {
    __extends(AngleAxis, _super);
    function AngleAxis() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'angleAxis';
        _this.shortType = 'angle';
        _this.crossLine = new Line({ key: Math.random(), display: false, pointerEvents: 'none' });
        _this.crossShadow = new Sector({
            key: Math.random(),
            display: false,
            pointerEvents: 'none',
        });
        return _this;
    }
    AngleAxis.prototype.getInitialState = function () {
        return {
            min: 0,
            max: 0,
            cx: 0,
            cy: 0,
            startAngle: 0,
            endAngle: 0,
            radius: 0,
            innerRadius: 0,
            crossAt: 0,
        };
    };
    AngleAxis.prototype.beforeRender = function () {
        var _a = this.parentModel.getState(), cx = _a.cx, cy = _a.cy, radius = _a.radius, innerRadius = _a.innerRadius, startAngle = _a.startAngle, endAngle = _a.endAngle;
        this.setState({
            cx: cx,
            cy: cy,
            startAngle: startAngle,
            endAngle: endAngle,
            radius: radius,
            innerRadius: innerRadius,
        });
        this.crossShadow.setAttr({ clip: this.parentModel.getClipPath() });
        this.initScale();
    };
    AngleAxis.prototype.initScale = function () {
        var _a = this.getExtreme(), min = _a[0], max = _a[1];
        this.setState({ min: min, max: max });
        var _b = this.option, type = _b.type, nice = _b.nice, ticks = _b.ticks, tickCount = _b.tickCount, exactTickCount = _b.exactTickCount, interval = _b.interval, minInterval = _b.minInterval, maxInterval = _b.maxInterval, padding = _b.padding, allowDecimals = _b.allowDecimals;
        var _c = this.parentModel.getState(), startAngle = _c.startAngle, endAngle = _c.endAngle;
        var start = startAngle;
        var end = endAngle;
        var isCircle = Math.abs(end - start) >= 360;
        var usePolygonShape = this.parentModel.getOption().shape === 'polygon';
        if (type === axisType.VALUE || type === axisType.LOG) {
            var scale = type === axisType.VALUE
                ? new LinearScale(min, max, start, end)
                : new LogScale(min, max, start, end);
            nice &&
                scale.niceTicks(tickCount, {
                    interval: interval,
                    ticks: ticks,
                    minInterval: minInterval,
                    maxInterval: maxInterval,
                    exactTickCount: exactTickCount,
                    allowDecimals: allowDecimals,
                });
            this.scale = scale;
        }
        else if (type === axisType.CATEGORY) {
            var categoies = this.getCategories();
            var scale = void 0;
            if (usePolygonShape) {
                if (isCircle) {
                    var gap = (end - start) / (max - min + 1) / 2;
                    scale = new OrdinalScale(categoies, min - 0.5, max + 0.5, start - gap, end - gap);
                }
                else {
                    scale = new OrdinalScale(categoies, min, max, start, end);
                }
            }
            else {
                var gap = isCircle && !padding ? (end - start) / (max - min + 1) / 2 : 0;
                scale = new OrdinalScale(categoies, min - 0.5, max + 0.5, start - gap, end - gap);
            }
            this.scale = scale;
        }
        this.scale.setFormatter(this.option.axisLabel.formatter);
    };
    AngleAxis.prototype.invertPoint = function (x, y) {
        var angle = this.parentModel.getCoordinate().pointToData(x, y).angle;
        return angle;
    };
    AngleAxis.prototype.pointToCoord = function (x, y) {
        var angle = this.parentModel.getCoordinate().pointToCoord(x, y).angle;
        return angle;
    };
    AngleAxis.prototype.getCrossPosition = function () {
        var startAngle = this.parentModel.getState().startAngle;
        return startAngle;
    };
    AngleAxis.prototype.showCrosshair = function (x, y, type) {
        var _a = this.state, cx = _a.cx, cy = _a.cy, innerRadius = _a.innerRadius, radius = _a.radius;
        var polarCoord = this.parentModel.getCoordinate();
        var useShadow = (this.shoudUseShadowPointer() && type !== 'line') || type === 'shadow';
        if (this.isCategroy()) {
            var index = Math.round(this.invertPoint(x, y));
            var shadowStartAngle = this.scale.scale(index - 0.5);
            var shadowEndAngle = this.scale.scale(index + 0.5);
            var angle = this.scale.scale(index);
            var startPoint = polarCoord.coordToPoint({ angle: angle, radius: innerRadius });
            var endPoint = polarCoord.coordToPoint({ angle: angle, radius: radius });
            this.crossLine.setAttr(__assign({ display: !useShadow, x1: startPoint.x, y1: startPoint.y, x2: endPoint.x, y2: endPoint.y }, this.getCrossLineStyle()));
            this.crossShadow.setAttr(__assign({ display: useShadow, cx: cx,
                cy: cy,
                radius: radius, radiusI: innerRadius, start: degToRad(shadowStartAngle), end: degToRad(shadowEndAngle) }, this.getCrossShadowStyle()));
        }
        else {
            var angle = polarCoord.pointToCoord(x, y).angle;
            var startPoint = polarCoord.coordToPoint({
                angle: angle,
                radius: innerRadius,
            });
            var endPoint = polarCoord.coordToPoint({
                angle: angle,
                radius: radius,
            });
            this.crossShadow.setAttr({ display: false });
            this.crossLine.setAttr(__assign({ display: !useShadow, x1: startPoint.x, y1: startPoint.y, x2: endPoint.x, y2: endPoint.y }, this.getCrossLineStyle()));
        }
    };
    AngleAxis.prototype.renderPolarArc = function () {
        var _this = this;
        var _a = this.parentModel.getState(), cx = _a.cx, cy = _a.cy, radius = _a.radius, startAngle = _a.startAngle, endAngle = _a.endAngle;
        var usePolygonShape = this.parentModel.getOption().shape === 'polygon';
        if (!usePolygonShape) {
            return new Arc(__assign(__assign({ cx: cx,
                cy: cy,
                radius: radius, start: degToRad(startAngle), end: degToRad(endAngle) }, this.getLineStyle(this.option.axisLine)), { onEvent: function (event) { return _this.handleUIEvent(event, eventGraph.AXIS_LINE, {}); } }));
        }
        var points = this.scale.getTicks().map(function (tick) {
            return _this.parentModel.getCoordinate().coordToPoint({
                angle: _this.scale.scale(tick),
                radius: radius,
            });
        });
        return new Polygon(__assign(__assign({ pointList: points }, this.getLineStyle(this.option.axisLine)), { onEvent: function (event) { return _this.handleUIEvent(event, eventGraph.AXIS_LINE, {}); } }));
    };
    AngleAxis.prototype.renderAlternateColor = function () {
        var ticks = this.getIntervalTicks();
        var ignoreColor = 'rgba(0, 0, 0, 0)';
        var colors = normalizeToArray(this.option.alternateColor);
        if (colors.length === 1) {
            colors.unshift(ignoreColor);
        }
        var _a = this.parentModel.getState(), cx = _a.cx, cy = _a.cy, radius = _a.radius, innerRadius = _a.innerRadius;
        var usePolygonShape = this.parentModel.getOption().shape === 'polygon';
        var group = new Group({
            key: this.getKey('axis-alternateColor'),
            clip: usePolygonShape
                ? new Polygon({
                    pointList: this.parentModel.radiusAxis.getPolygonPointsOnRadius(radius),
                })
                : null,
        });
        if (ticks.length <= 1 || this.getAxisSeries().length === 0) {
            return group;
        }
        for (var i = 0; i < (this.isCategroy() ? ticks.length : ticks.length - 1); i++) {
            var color = colors[i % colors.length];
            if (color === ignoreColor) {
                continue;
            }
            var isLast = i === ticks.length - 1;
            var current = ticks[i];
            var next = ticks[i + 1];
            var start = this.isCategroy() ? this.scale.scale(current - 0.5) : this.scale.scale(current);
            var end = this.isCategroy()
                ? isLast
                    ? this.scale.end
                    : this.scale.scale(next - 0.5)
                : this.scale.scale(next);
            group.add(new Sector({
                cx: cx,
                cy: cy,
                radius: radius,
                radiusI: innerRadius,
                start: degToRad(start),
                end: degToRad(end),
                fill: color,
            }));
        }
        return group;
    };
    AngleAxis.prototype.renderTickLines = function () {
        var _this = this;
        var _a = this.state, startAngle = _a.startAngle, endAngle = _a.endAngle, radius = _a.radius;
        var tickLine = this.option.tickLine;
        var tickGroup = new Group({
            key: this.getKey('axis-tick'),
        });
        var inside = tickLine.inside, length = tickLine.length;
        var isCircle = Math.abs(endAngle - startAngle) >= 360;
        var tickList = this.getIntervalTicks();
        if (isCircle && !this.isCategroy()) {
            tickList = tickList.slice(0, -1);
        }
        tickList.forEach(function (tick) {
            var tickAngle = _this.scale.scale(tick);
            var startPoint = _this.parentModel.getCoordinate().coordToPoint({
                angle: tickAngle,
                radius: radius,
            });
            var endPoint = _this.parentModel.getCoordinate().coordToPoint({
                angle: tickAngle,
                radius: inside ? radius - length : radius + length,
            });
            tickGroup.add(new Line(__assign(__assign({ x1: startPoint.x, y1: startPoint.y, x2: endPoint.x, y2: endPoint.y }, _this.getLineStyle(_this.option.tickLine)), { onEvent: function (event) { return _this.handleUIEvent(event, eventGraph.AXIS_TICKS, {}); } })));
        });
        return tickGroup;
    };
    AngleAxis.prototype.renderGridLines = function () {
        var _this = this;
        var gridGroup = new Group({
            key: this.getKey('axis-gridline'),
        });
        var _a = this.state, startAngle = _a.startAngle, radius = _a.radius, innerRadius = _a.innerRadius;
        this.getIntervalTicks().forEach(function (tick) {
            var gridAngle = _this.scale.scale(tick);
            if ((gridAngle - startAngle) % 360 === 0) {
                return;
            }
            var startPoint = _this.parentModel.getCoordinate().coordToPoint({
                angle: gridAngle,
                radius: innerRadius,
            });
            var endPoint = _this.parentModel.getCoordinate().coordToPoint({
                angle: gridAngle,
                radius: radius,
            });
            var gridLine = new Line(__assign(__assign({ x1: startPoint.x, y1: startPoint.y, x2: endPoint.x, y2: endPoint.y }, _this.getLineStyle(_this.option.gridLine)), { onEvent: function (event) { return _this.handleUIEvent(event, eventGraph.AXIS_GRID, {}); } }));
            gridGroup.add(gridLine);
        });
        return gridGroup;
    };
    AngleAxis.prototype.renderLabels = function () {
        var _this = this;
        var labelGroup = new Group({
            key: this.getKey('axis-label'),
        });
        var _a = this.state, radius = _a.radius, startAngle = _a.startAngle, endAngle = _a.endAngle;
        var axisLabel = this.option.axisLabel;
        var inside = axisLabel.inside, margin = axisLabel.margin;
        var isCircle = Math.abs(endAngle - startAngle) >= 360;
        var tickList = this.getIntervalTicks();
        if (isCircle && !this.isCategroy()) {
            tickList = tickList.slice(0, -1);
        }
        tickList.forEach(function (tick) {
            var text = _this.scale.getLabel(tick);
            var angle = _this.scale.scale(tick);
            var point = _this.parentModel.getCoordinate().coordToPoint({
                angle: angle,
                radius: radius + margin * (inside ? -1 : 1),
            });
            var x = point.x, y = point.y;
            var _a = getCircleLayoutLabelAlign(angle, inside), textAlign = _a.textAlign, textBaseline = _a.textBaseline;
            labelGroup.add(createRichText(__assign(__assign({ x: x,
                y: y,
                text: text,
                textAlign: textAlign,
                textBaseline: textBaseline }, _this.getTextStyle(_this.option.axisLabel)), { onEvent: function (event) { return _this.handleUIEvent(event, eventGraph.AXIS_LABEL, {}); } })));
        });
        return labelGroup;
    };
    AngleAxis.prototype.render = function () {
        var group = new Group({
            key: this.getKey('axis-group'),
        });
        if (this.option.show) {
            if (this.option.alternateColor) {
                group.add(this.renderAlternateColor());
            }
            if (this.option.axisLine.show) {
                group.add(this.renderPolarArc());
            }
            if (this.option.gridLine.show) {
                group.add(this.renderGridLines());
            }
            if (this.option.tickLine.show) {
                group.add(this.renderTickLines());
            }
            if (this.option.axisLabel.show) {
                group.add(this.renderLabels());
            }
        }
        this.chart.addToTopLevel(this.crossLine);
        this.chart.addToTopLevel(this.crossShadow);
        return group;
    };
    return AngleAxis;
}(Axis));
export default AngleAxis;
